<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group mb-4 text-right">
                  <div class="button-items">
                    <b-dropdown text="Add Product" variant="success">
                      <template slot="button-content"
                        >Add Product<i class="mdi mdi-chevron-down"></i
                      ></template>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeAddProduct = 'Import Excel'
                        "
                        v-if="mode == 'new'"
                        >Import Excel
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeAddProduct = 'Condition'
                        "
                        v-if="mode == 'edit'"
                        >Condition
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeAddProduct = 'Add Product'
                        "
                        v-if="mode == 'new'"
                        >Add Product
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <h4 class="card-title mb-4">
                  Product
                </h4>
                <div class="row">
                  <div class="col-sm-12 col-md-6"></div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="searchProductCostPromotion"
                          type="search"
                          placeholder="Search"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="productTable"
                        :empty-text="'ไม่พบข้อมูล'"
                        :show-empty="productItems.length == 0"
                        :bordered="true"
                        :filter="searchProductCostPromotion"
                        :items="productItems"
                        align="center"
                        v-bind:fields="fields"
                        :perPage="perPage"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (firstRowOnPage + data.index) | number }}
                          </div>
                        </template>
                        <template v-slot:cell(inventory_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template v-slot:cell(sale_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <!-- <template
                          v-slot:cell(cost_promotion_exclude_vat)="data"
                        >
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index]
                                .cost_promotion_exclude_vat
                            "
                            type="number"
                            class="form-control form-default text-right"
                          />
                        </template>
                        <template v-slot:cell(promotion_start_date)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index].promotion_start_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                        </template>
                        <template v-slot:cell(promotion_end_date)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index].promotion_end_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                        </template>
                        <template v-slot:cell(product_remark)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="productItems[data.index].product_remark"
                            type="text"
                            class="form-control form-default text-left"
                          />
                        </template> -->
                        <template v-slot:cell(promotion_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template v-slot:cell(action)="data">
                          <div class="text-center">
                            <a
                              @click="onDeleteProduct(data.item.id)"
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-light"
                          @click="onCancel()"
                        >
                          <i
                            class="bx bx-arrow-back font-size-16 align-middle mr-2"
                          ></i>
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          v-if="
                            productItems !== null && productItems.length > 0
                          "
                        >
                          Save
                        </button>
                        <button
                          type="reset"
                          class="btn btn-secondary"
                          v-if="
                            productItems !== null && productItems.length > 0
                          "
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <sideBar
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      :modeAddProduct="modeAddProduct"
      :listProductItems="productItems"
      :mode="mode"
      @hidden="toggleSideBar = false"
      @getDataSideBar="getDataSideBar"
    ></sideBar>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import productCostPromotionService from '@/helpers/service/product-cost-promotion-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import moment from 'moment'
import sideBar from '@/components/product-cost-promotions/sideBar'
import { BasicSelect } from 'vue-search-select'

export default {
  page: {
    title: 'Cost Promotion',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    sideBar,
  },
  data() {
    return {
      optionsStatus: [
        { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
        { text: StatusEnum.DELETE, value: StatusEnum.DELETE },
      ],
      reloadPromotionStatusSelector: false,
      id: '',
      title: 'New Cost Promotion',
      mode: 'new',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Pricing : Cost Promotion',
          href: '/product-cost-promotions',
        },
        {
          text: 'New Cost Promotion',
          active: true,
        },
      ],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'is_vat',
          label: 'สินค้าคิดภาษี (Vat)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'discount_rate',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ส่วนลดในตัว (%)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุนหน่วยซื้อ (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุน Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_start_date',
          label: 'วันและเวลาเริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_end_date',
          label: 'วันและเวลาสิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_remark',
          label: 'หมายเหตุการปรับราคา',
          tdClass: 'text-left',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      perPage: 9999,
      firstRowOnPage: 1,
      productItems: [],
      toggleSideBar: false,
      modeAddProduct: '',
      searchProductCostPromotion: null,
      pageNo: 1,
      pageSize: 99999,
    }
  },
  watch: {
    productItems: {
      handler: function(val) {
        val.forEach(element => {
          if (element.is_error) {
            element._rowVariant = 'danger'
          } else {
            element._rowVariant = ''
          }
        })
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Cost Promotion'
      this.items[2].text = 'New Cost Promotion'
    } else if (this.$route.params.id == 'edit') {
      this.mode = 'edit'
      this.title = 'Edit Cost Promotion'
      this.items[2].text = 'Edit Cost Promotion'
      this.fields = [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'is_vat',
          label: 'สินค้าคิดภาษี (Vat)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'discount_rate',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ส่วนลดในตัว (%)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุนหน่วยซื้อ (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุน Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_start_date',
          label: 'วันและเวลาเริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_end_date',
          label: 'วันและเวลาสิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_status',
          label: 'สถานะ Promotion',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_remark',
          label: 'หมายเหตุการปรับราคา',
          tdClass: 'text-left',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ]
    }
  },
  mounted: function() {},
  methods: {
    onCancel() {
      this.$router.push({
        path: '/product-cost-promotions',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.productItems = []
          }
        })
    },
    async onSubmit() {
      if (this.productItems.some(s => s.is_error == true)) {
        this.$utils.notification(
          'error',
          'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
          3000
        )
      } else {
        if (this.mode == 'new') {
          let result = await productCostPromotionService.createProductCostPromotionListAsync(
            this.productItems
          )
          if (result.status === 201) {
            this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 2000)
            this.$router.push({
              path: '/product-cost-promotions',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        } else {
          let result = await productCostPromotionService.updateProductCostPromotionListAsync(
            this.productItems
          )
          if (result.status && result.status === 204) {
            this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 2000)
            this.$router.push({
              path: '/product-cost-promotions',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        }
      }
    },
    onDeleteProduct(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )
    },
    onClearProduct() {
      this.productItems = []
    },
    async onPromotionStatusSelectorInConditionList(data, index) {
      this.reloadPromotionStatusSelector = false
      this.productItems[index].promotion_status = data.text ? data.text : ''
    },
    async getDataSideBar(value) {
      value.forEach(element => {
        if (
          this.productItems.find(
            p =>
              p.id === element.id &&
              p.promotion_start_date === element.promotion_start_date &&
              p.promotion_end_date === element.promotion_end_date
          ) !== undefined
        ) {
          this.productItems.find(
            p =>
              p.id == element.id &&
              p.promotion_start_date === element.promotion_start_date &&
              p.promotion_end_date === element.promotion_end_date
          ).cost_promotion_exclude_vat == element.cost_promotion_exclude_vat
          this.productItems.find(
            p =>
              p.id == element.id &&
              p.promotion_start_date === element.promotion_start_date &&
              p.promotion_end_date === element.promotion_end_date
          ).product_remark = element.product_remark
          this.productItems.find(
            p =>
              p.id == element.id &&
              p.promotion_start_date === element.promotion_start_date &&
              p.promotion_end_date === element.promotion_end_date
          ).promotion_status = element.promotion_status
        } else {
          this.productItems.push(element)
        }
      })
    },
  },
}
</script>
